import React, { Component } from 'react';
import { Utils } from 'services/utils';
import StorageDonut from 'sub_components/Common/StorageDonut';

const RESOLUTIONS = {
	DAY: 'd',
	HOUR: 'h',
	MONTH: 'm',
};

class StorageUsage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			share: null,
			data: null,
			rawData: null,
			dataResponse: null,
			unit: null,
			error: null,
			rangeMin: null,
			rangeMax: null,
			currMin: null,
			currMax: null,
			usage: null,
			resolution: RESOLUTIONS.DAILY,
		};
	}

	componentDidUpdate(prevProps) {
		const { data, usage } = this.props;
		const { data: currentData } = this.state;

		if (data !== prevProps.data || data !== currentData) {
			this.setState({ data });
		}
		if (usage !== prevProps.usage) {
			this.setState({ usage });
		}
	}

	componentDidMount() {
		const { data, usage } = this.props;

		this.setState({ data, usage });
	}

	render() {
		const { unit, breakpoint, navigate, total, packageData } = this.props;
		const { data, usage } = this.state;
		const objectLocations = data ? data?.object : [];
		let locationLength = objectLocations && objectLocations.length === 1 ? 'single' : 0;
		if (objectLocations && objectLocations.length === 4) {
			locationLength = 'four';
		}

		return (
			<div className={`storage-usage-wrapper`}>
				<div className='package-details'>
					{data && usage && (
						<StorageDonut
							data={data}
							commitment={total}
							commitmentUnit={unit}
							ticketType={'Support'}
							id='storage2'
							breakpoint={breakpoint}
							navigate={navigate}
							packageData={packageData}
							unit={unit}
							usage={usage}
						/>
					)}
				</div>
				<div className='location-details'>
					{objectLocations && objectLocations.length !== 0 && (
						<div className={`datacenter-locations ${locationLength}`}>
							{objectLocations.map(location => (
								<div className='datacenter'>
									<div className='name heading70'>
										{Utils.getLocationNameByTag(location?.location)}
									</div>
									<div className='size heading52'>
										{location[`size${unit}`]}

										<span className='unit'>{unit}</span>
									</div>
								</div>
							))}
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default StorageUsage;
